import React from "react";
import "./About.css";
import aboutImg from "../../img/hands-register.png"; // use your existing image
import Footer from "../../components/Footer/Footer";
import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect } from "react";

const About = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
    });
  }, []);
  return (
    <>
      <section className="about-section">
        <div className="about-container-custom">
          {/* Left Side Image */}
          <div className="about-image-wrapper" data-aos="fade-right">
            <div className="about-image">
              <img src={aboutImg} alt="Truck Dispatching" />
            </div>
          </div>

          {/* Right Side Content */}
          <div
            className="about-content"
            data-aos="fade-left"
            data-aos-duration="500"
          >
            <h2>About LivoSol Dispatching</h2>

            <div className="about-line"></div>

            <p>
              At LivoSol Dispatching, we specialize in providing reliable and
              efficient freight dispatch services for owner-operators and
              trucking companies across the United States.
            </p>

            <p>
              Our experienced dispatchers work tirelessly to secure the best
              paying loads, handle paperwork, negotiate rates, and manage your
              logistics so you can focus on driving and growing your business.
            </p>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default About;
